import axios from '@axios'

const route = 'register/reserve_channel'

export default {
  namespaced: true,
  actions: {
    getAll(context, { itemsPerPage, page }) {
      return axios.get(`${route}?page=${page}&items_per_page=${itemsPerPage}`)
    },
    getActive() {
      return axios.get(`${route}/select`)
    },
    getLegacyOrigins() {
      return axios.get(`${route}/legacy_origins`)
    },
    assignLegacyReserves(context, { channel, origins }) {
      return axios.post(`${route}/${channel.id}/legacy_reserves`, { origins })
    },
    store(context, channel) {
      return axios.post(route, channel)
    },
    update(context, channel) {
      return axios.put(`${route}/${channel.id}`, channel)
    },
    deactivate(context, channel) {
      return axios.delete(`${route}/${channel.id}`)
    },
  },
}
